module.exports = __webpack_public_path__ + "img/icon-cancel.5b5be94a.svg";